import { OverlayPanel } from "primereact/overlaypanel";
import LoadingOverlay from "react-loading-overlay-ts";

import "./index.scss";

export default function ProfileDropdown({
  profileDropdownRef,
  loader,
  setOutOfNotification,
  handleProfileDropdown,
}) {
  return (
    <OverlayPanel ref={profileDropdownRef} className="dropdown-overlay" dismissable={false}>
      <LoadingOverlay active={loader} spinner text=""></LoadingOverlay>
      <div className="profile-dropdown">
        <ul>
          <li
            onClick={(e) => {
              setOutOfNotification(true);
              handleProfileDropdown(e);
            }}
          >
            Out of Office
          </li>
        </ul>
      </div>
    </OverlayPanel>
  );
}